import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import api from '../../services/api';
import { downloadBlobAsFile } from './lib';
import { FILE_EXTENSIONS_TYPE } from './constants';
import { useSelector } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import { CircularProgress, Typography } from '@mui/material';
import { BASE_URL } from '../../constants/api';

const DownloadButton = ({
  data,
  filename,
  fileType,
  setIsDownload = () => { },
  setIsDownloading = () => { },
  downloadCheck,
  tab = '',
  isDownloading = false,
  isDisabled = false,
  mapDownload = false,
  showWonOpps = false,
  year,
  isAudienceAnalysisTab = false,
}) => {
  const [reportData, setReportData] = useState([])
  const { userData } = useSelector(state => state.auth)
  const storeArray = userData?.data?.stores_data?.map(store => store.branch_number)
  const [storeList, setStoreList] = useState(storeArray);
  const [reportIsDownloading, setReportIsDownloading] = useState(false);

  useEffect(() => {
    setReportData(data)
  }, [data])

  const getDownloadedReport = async data => {
    if (data?.length > 0 || (mapDownload && isDownloading)) {
      try {
        let result;
        if (mapDownload && isDownloading) {
          result = await api.get(`${BASE_URL}maps/download?fiscal_year=${year}&level=zip${showWonOpps ? '&level=won_opps' : ''}`, {
            responseType: 'blob',
          });
        } else {
          result = await api.post(`/api/v1/store/download?tab=${tab}`, data, {
            responseType: 'blob'
          })
        }
        setIsDownloading(false)
        return result
      } catch (error) {
        setIsDownloading(false)
        console.error(error)
      }
    }
  }

  const handleDownload = async ({ downloadCheck, reportData, storeList }) => {
    if ((downloadCheck && reportData?.length === storeList?.length) || (mapDownload && isDownloading)) {
      let response = null
      try {
        let type = fileType
        if (!type) {
          const splits = filename.split('.')
          type = FILE_EXTENSIONS_TYPE[splits[splits.length - 1]]
        }
        if (!type) {
          throw new Error(
            'Could not determine file type, either pass `fileType` as `props` or provide a valid file extension and type mapping in `constants/index'
          )
        }
        response = getDownloadedReport(reportData)
        response
          .then(
            res => {
              downloadBlobAsFile(res?.data, filename, type);
              setReportIsDownloading(false);
            },
            async res => {
              const jsonText = JSON.parse(await res?.response?.data?.text())
            }
          )
          .catch(ex => {
            console.error(ex)
          })
      } catch (ex) {
        setIsDownloading(false)
        setReportIsDownloading(false);
        console.error(ex)
      }
    } else {
      setIsDownloading(false)
    }
  }

  useEffect(() => {
    handleDownload({ downloadCheck, reportData, storeList })
  }, [fileType, filename, reportData, downloadCheck, isDownloading])

  return (
    <Tooltip title={mapDownload ? "" : null} placement="bottom">
        <Button
          onClick={() => {
            setReportIsDownloading(true);
            setIsDownload(true);
            setIsDownloading(true);
          }}
          style={{ display: 'flex', gap: '15px', backgroundColor: '#e4e4e7', marginTop: isAudienceAnalysisTab ? '12px' : '6px', height:'40px' }}
          disabled={isDownloading || isDisabled || reportIsDownloading}
        >
          {!mapDownload ?
            <Tooltip title="Download Report" placement="bottom">
              {(isDownloading || reportIsDownloading) ? <CircularProgress size="2rem"  sx={{ color: '#000' }} /> : <CloudDownloadIcon />}
            </Tooltip> :
            <div style={{ display: 'flex', flexDirection: 'row', gap: 15 }}><Typography variant='subtitle1' fontWeight='450'>Download</Typography> {isDownloading ? <CircularProgress size="2rem" sx={{ color: '#000' }} /> : <CloudDownloadIcon />}</div>
          }
        </Button>
    </Tooltip>
  )
}

export default DownloadButton;

DownloadButton.propTypes = {
  data: PropTypes.array,
  filename: PropTypes.string.isRequired,
  fileType: PropTypes.string,
  setIsDownload: PropTypes.func,
  setIsDownloading: PropTypes.func,
  downloadCheck: PropTypes.bool,
  tab: PropTypes.string,
  isDownloading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  mapDownload: PropTypes.bool,
  showWonOpps: PropTypes.bool,
  year: PropTypes.number,
  isAudienceAnalysisTab: PropTypes.bool
}